// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  error: false,
  broadcastsListStatus: { data: null },
  createBroadcastsStatus: { data: null },
  deleteBroadcastStatus: { data: null },
  getBroadcastByIdStatus: { data: null },
};
